export default {
  priv: 'pr_device',
  detailTitle: '',
  deleteTitle: 'dit item',
  overviewUrl: '/devices/tests/{test_id}',
  url: '/devices/tests/{test_id}/lines',
  apiUrl: '/devicetests/{test_id}/lines/'
};
